import { OptionProps } from 'react-select/src/components/Option';
import React from 'react';
import { CustomSelectOption } from './CustomSelect';
import './CustomSelectDropdownOption.scss';
import classNames from 'classnames';
import Tooltip from './Tooltip';
import infoIcon from '../imgs/icons/info.svg';

export function CustomSelectDropdownOption<TOption extends CustomSelectOption>(props: OptionProps<TOption, false>) {
	const option = props.data as TOption;
	return (
		<div ref={props.innerRef} { ...props.innerProps }>

			<div className={classNames('custom-select-dropdown-option__container', { 'custom-select-dropdown-option__container_selected': props.isSelected, 'custom-select-dropdown-option__container_focused': props.isFocused, 'custom-select-dropdown-option__container_disabled': props.isDisabled })}>
				<div className="flex flex-align-center">
					<div className="flex-item-growing-shrinking">{props.label}</div>
					
					{!!option.tooltipText &&
						<div className="flex-item-static">
							<Tooltip placement="top" content={option.tooltipText} fallbackPlacements={['top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end']}>
								<img src={infoIcon} alt="Information" aria-label={option.tooltipText} tabIndex={0} className="pretty-focus custom-select-dropdown-option__info-icon" />
							</Tooltip>
						</div>
					}
					
					{!!option.descriptionText &&
						<div className="flex-item-static custom-select-dropdown-option__description-text">
							{option.descriptionText}
						</div>
					}
				</div>
			</div>
		</div>
	)
}